import React from "react";
import Meta from "./../components/Meta";
import HeroSection from "./../components/HeroSection";
import GeneratorSection from "./../components/GeneratorSection";
import HeroSection2 from "./../components/HeroSection2";
import HeroSection3 from "./../components/HeroSection3";
import ContentCardsSection from "./../components/ContentCardsSection";
import FeaturesSection from "./../components/FeaturesSection";
import FaqSection from "./../components/FaqSection";
import { AgeVerification } from "../components/AgeVerification";
import HeroSection4 from "../components/HeroSection4";


function IndexPage(props) {
    const ageVerified = localStorage.getItem('ageVerified');

  return (
    <>
      <Meta />
      {ageVerified !== 'true' && <AgeVerification />}

      <HeroSection
        bgColor="secondary"
        size="large"
        bgImage="https://i.imgur.com/8L1xFWh.png"
        bgImageOpacity={0.2}
        title="NSFW AI Art Generator"
        smallTitle="Unleash Your Wildest Fantasies with this Erotic, Uncensored AI Art Generator"
        subtitle="Dive into the world of AI-powered nude generator, where your deepest desires come to life. From hyper-realistic to anime styles, our generator crafts impeccable NSFW erotic art tailored to your needs."
        buttonText="Get Started"
        buttonColor="primary"
        buttonPath="/create"
      />
      <HeroSection2
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Diverse Styles"
        subtitle="Choose from Real, Hyper Real, Anime, and Hyper Anime"
        image="https://waifu-files.faceplay.me/cdn-cgi/image/width=600,quality=85/https://www.faceplay.me/sg/home/images/desc-1-default.png"
        buttonText="Get Started"
        buttonColor="primary"
        buttonPath="/create"
      />
      <HeroSection3
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Exciting Poses"
        subtitle="We provides more than 20 different poses.From DoggyStyle to POV to BDSM, we got you cover. You are already in the best NSFW AI art gallery. Click the button to explore our AI art treasures"
        image="https://waifu-files.faceplay.me/cdn-cgi/image/width=600,quality=85/https://www.faceplay.me/sg/home/images/desc-2-default.png"
        buttonText="Get Started"
        buttonColor="primary"
        buttonPath="/create"
      />
      <HeroSection4
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Privacy First"
        subtitle="Generate art discreetly, ensuring your fantasies remain private."
        image="https://waifu-files.faceplay.me/cdn-cgi/image/width=600,quality=85/https://www.faceplay.me/sg/home/images/desc-3-default.png"
        buttonText="Get Started"
        buttonColor="primary"
        buttonPath="/create"
      />
  
      <FaqSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        title="Frequently Asked Questions"
        subtitle=""
      />
    </>
  );
}

export default IndexPage;
